import { Box, Button } from '@mui/material';
import { StyledPaper, PageTitle, Paragraph } from 'components/layouts/SharedStyles';
import { config } from 'config';

const { costRange } = config.admissions;

export const Check = () => {
  return (
    <StyledPaper extraStyles={{ maxWidth: 750 }}>
      <Box sx={{ textAlign: 'center', margin: '0 auto' }}>
        <PageTitle>
          Paying by check
        </PageTitle>

        <Paragraph>
          If you are paying by check, please do not fill out this form.
        </Paragraph>
        <Paragraph>
          Instead, send a check made out to PCDC, and mail it by the end of February to:<br />
          Sue Songer, 4405 SW Redondo Ave, Portland OR 97239
        </Paragraph>
        <Paragraph>
          Please include with your check a note containing:<br />
          your name, email, phone, and the name of anyone else you're registering
        </Paragraph>
        <Paragraph>
          The suggested cost is $25, with a sliding scale from ${costRange[0]}-{costRange[1]} per person.
        </Paragraph>
      </Box>

      <Button variant='contained' color='primary' href='/' >
        Back
      </Button>
    </StyledPaper>
  );
}
